import { mallErrorFragment } from "@saleor/fragments/errors";
import { mallDetailsFragment } from "@saleor/fragments/mall";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { MallCreate, MallCreateVariables } from "./types/MallCreate";
import {
  MallDeactivate,
  MallDeactivateVariables
} from "./types/MallDeactivate";
import { MallUpdate, MallUpdateVariables } from "./types/MallUpdate";
import {
  MallUpdateOrderTimeframe,
  MallUpdateOrderTimeframeVariables
} from "./types/MallUpdateOrderTimeframe";
import {
  MallUpdateStatus,
  MallUpdateStatusVariables
} from "./types/MallUpdateStatus";

export const mallCreateMutation = gql`
  ${mallDetailsFragment}
  ${mallErrorFragment}
  mutation MallCreate($input: MallCreateInput!) {
    mallCreate(input: $input) {
      mall {
        ...MallDetailsFragment
      }
      errors: mallErrors {
        ...MallErrorFragment
      }
    }
  }
`;
export const useMallCreateMutation = makeMutation<
  MallCreate,
  MallCreateVariables
>(mallCreateMutation);

export const mallUpdateMutation = gql`
  ${mallDetailsFragment}
  ${mallErrorFragment}
  mutation MallUpdate($id: ID!, $input: MallUpdateInput!) {
    mallUpdate(id: $id, input: $input) {
      mall {
        ...MallDetailsFragment
      }
      errors: mallErrors {
        ...MallErrorFragment
      }
    }
  }
`;
export const useMallUpdateMutation = makeMutation<
  MallUpdate,
  MallUpdateVariables
>(mallUpdateMutation);

export const mallUpdateStatusMutation = gql`
  ${mallDetailsFragment}
  ${mallErrorFragment}
  mutation MallUpdateStatus($id: ID!, $status: SmopStatusEnum!) {
    updateMallStatus(id: $id, status: $status) {
      mall {
        ...MallDetailsFragment
      }
      errors: mallErrors {
        ...MallErrorFragment
      }
    }
  }
`;
export const useMallUpdateStatusMutation = makeMutation<
  MallUpdateStatus,
  MallUpdateStatusVariables
>(mallUpdateStatusMutation);

export const mallDeactivate = gql`
  ${mallDetailsFragment}
  ${mallErrorFragment}
  mutation MallDeactivate($id: ID!, $input: MallUpdateInput!) {
    mallUpdate(id: $id, input: $input) {
      mall {
        ...MallDetailsFragment
      }
      errors: mallErrors {
        ...MallErrorFragment
      }
    }
  }
`;
export const useMallDeactivate = makeMutation<
  MallDeactivate,
  MallDeactivateVariables
>(mallDeactivate);

export const mallUpdateOrderTimeframe = gql`
  ${mallErrorFragment}
  mutation MallUpdateOrderTimeframe(
    $mallId: ID!
    $shippingMethodId: ID!
    $startTime: Time
    $endTime: Time
  ) {
    updateMallOrderTimeframe(
      mallId: $mallId
      shippingMethodId: $shippingMethodId
      startTime: $startTime
      endTime: $endTime
    ) {
      mall {
        id
        name
      }
      errors: mallErrors {
        ...MallErrorFragment
      }
    }
  }
`;
export const useMallUpdateOrderTimeframe = makeMutation<
  MallUpdateOrderTimeframe,
  MallUpdateOrderTimeframeVariables
>(mallUpdateOrderTimeframe);
